<template>
  <div class="fmcloud">
    <div class="fmTop">
      <div class="fmtit">
        <span class="tit">{{ $t("Fm2shortlinkbate.Redirectst") }}</span>
        <div class="behind">
          <div
            :class="{
              inside: true,
              insideA: isInside == 0,
            }"
            @click="changeType(0)"
          >
            {{ $t("Fm2shortlinkbate.ViewsViews") }}
          </div>
          <div
            :class="{
              inside: true,
              insideA: isInside == 1,
            }"
            @click="changeType(1)"
          >
            {{ $t("Fm2shortlinkbate.ViewsViewss") }}
          </div>
        </div>
        <span class="tips">（{{ $t("Fm2shortlinkbate.DataOverview2") }}）</span>
      </div>
      <el-date-picker
        v-model="picker1"
        style="width: 244px"
        size="small"
        type="daterange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions1"
        @change="handleDateChange1"
      >
      </el-date-picker>
    </div>
    <div class="echartBox">
      <div id="echart1" style="width: 932px; height: 405px"></div>
    </div>

    <div>
      <div class="fmTop" style="margin-top: 64px">
        <div class="fmtit">
          <span class="tit">{{ $t("Fm2shortlinkbate.Earnings") }}</span>
          <span class="tips"
            >（{{ $t("Fm2shortlinkbate.DataOverview2") }}）</span
          >
        </div>

        <el-date-picker
          v-model="picker2"
          style="width: 244px"
          size="small"
          type="daterange"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions2"
          @change="handleDateChange2"
        >
        </el-date-picker>
      </div>
      <div class="echartBox">
        <div id="echart2" style="width: 932px; height: 405px"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import {
  creditDataRendAPI,
  creditDataDarenRendAPI,
} from "@/utils/apiList/fmp";
import { getViewsChart } from "@/utils/apiList/shortlink";
export default {
  data() {
    return {
      picker1: [],
      picker2: [],
      isInside: 0,
      pickerOptions1: {
        disabledDate(time) {
          // 禁用当天和当天以后的日期
          return time.getTime() > Date.now() - 8.64e7; // 8.64e7 是一天的毫秒数
        }
      },
      pickerOptions2: {
        disabledDate(time) {
          // 禁用当天和当天以后的日期
          return time.getTime() > Date.now() - 8.64e7; // 8.64e7 是一天的毫秒数
        }
      },
      downNumList: [
        {
          id: 0,
          name: this.$t("FmCloud.TextTwo"),
          num: 0,
        },
        {
          id: 1,
          name: this.$t("FmCloud.TextThree"),
          num: 0,
        },
        {
          id: 2,
          name: this.$t("FmCloud.WeekAward"),
          num: 0,
          task_status: 1,
          taskId: 0,
        },
      ],
      memberList: [
        {
          id: 0,
          name: this.$t("FmCloud.VIPRebatesToday"),
          num: 0,
        },
        {
          id: 1,
          name: this.$t("FmCloud.CommissionBackToday"),
          num: 0,
        },
      ],
      downTable: {
        x: [],
        app_jump: [],
        applet_jump: [],
        login_jump: [],
        no_login_jump: [],
        file_count: 0,
      },
      darenTable: {
        x: [],
        app_jump: [],
        applet_jump: [],
        login_jump: [],
        no_login_jump: [],
        file_count: 0,
      },
    };
  },
  mounted() {
    // 设置默认时间为最近7天
    this.setDefaultDateRange();
    this.getData1();
    this.getData2();
  },
  methods: {
    // 设置默认日期范围为最近7天
    setDefaultDateRange() {
      const endDate = new Date();
      endDate.setDate(endDate.getDate() - 1); // 昨天
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 7); // 7天前
      
      this.picker1 = [startDate, endDate];
      this.picker2 = [startDate, endDate];
    },
    // 处理第一个时间选择器的变化
    handleDateChange1() {
      if (this.picker1 && this.picker1.length === 2) {
        this.getData1();
      }
    },
    // 处理第二个时间选择器的变化
    handleDateChange2() {
      if (this.picker2 && this.picker2.length === 2) {
        this.getData2();
      }
    },
    changeType(row) {
      if (this.isInside == row) {
        return;
      }
      this.isInside = row;
      // 切换类型后重新获取数据
      this.getData1();
    },
    initEchart1() {
      var chartDom = document.getElementById("echart1");
      var myChart = echarts.init(chartDom);
      var option;
      option = {
        legend: {
          data: [
            {
              name: this.$t("Fm2shortlinkbate.Loginjump11"),
              icon: "path://M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM7,2.5A4.5,4.5,0,1,0,11.5,7,4.51,4.51,0,0,0,7,2.5Z",
            },
            {
              name: this.$t("Fm2shortlinkbate.Miniadjump11"),
              icon: "path://M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM7,2.5A4.5,4.5,0,1,0,11.5,7,4.51,4.51,0,0,0,7,2.5Z",
            },
            {
              name: this.$t("Fm2shortlinkbate.Feemooadjump11"),
              icon: "path://M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM7,2.5A4.5,4.5,0,1,0,11.5,7,4.51,4.51,0,0,0,7,2.5Z",
            },
          ],
          bottom: 0,
        },
        tooltip: {
          // 设置tip提示
          trigger: "axis",
          formatter: function (params) {
            let result = "";
            result += `<div style="font-weight: 400;font-size: 12px;color: #8A8B92;line-height: 20px;;margin-bottom:8px">
              ${params[0].name}
            </div>`;
            params.forEach((item) => {
              const symbolstyle = ` 
                width: 8px;
                height: 8px;
                display:inline-block;
                border: 2.5px solid ${item.color};
                border-radius: 50%; 
                background-color: transparent; `;
              result += `
                <div style="display:flex;justify-content:space-between;align-items:center">
                  <div>
                    <span style="${symbolstyle}"></span>
                    <span style="margin-left:5px;margin-right:18px;font-weight: 400;font-size: 12px;color:#2C2C2C;">
                      ${item.seriesName}
                    </span>
                  </div>
                  <span style="font-weight: 400;font-size: 12px;color: #2C2C2C;">${item.value}</span>
                </div>`;
            });
            return result;
          },
          extraCssText:
            "box-shadow: 0px 8px 20px 0px rgba(0,0,0,0.06);border-radius: 8px;",
        },
        grid: {
          // 调整图表上下左右位置
          left: 0,
          right: 30,
          containLabel: true,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#8a8b92", // 更改坐标轴文字颜色
              fontSize: 14, // 更改坐标轴文字大小
            },
          },
        },
        xAxis: {
          // 设置x轴
          type: "category",
          data: this.downTable.x,
          axisLabel: {
            show: true,
            margin: 12,
            textStyle: {
              color: "#8a8b92", // 更改坐标轴文字颜色
              fontSize: 14, // 更改坐标轴文字大小
            },
          },
        },
        series: [
          {
            name: this.$t("Fm2shortlinkbate.Loginjump11"),
            data: this.downTable.login_jump,
            z: 2,
            type: "line",
            symbol:
              "path://M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM7,2.5A4.5,4.5,0,1,0,11.5,7,4.51,4.51,0,0,0,7,2.5Z",
            tooltip: {
              show: true,
            },
            symbolSize: 2,
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(236, 233, 255, 1)",
                },
                {
                  offset: 1,
                  color: "rgba(236, 233, 255, 0)",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "rgba(126, 114, 246, 1)", // 改变折线点的颜色
                lineStyle: {
                  color: "rgba(126, 114, 246, 1)", // 改变折线颜色
                  width: 2, // 设置线条粗细
                },
              },
            },
          },
          {
            name: this.$t("Fm2shortlinkbate.Miniadjump11"),
            data: this.downTable.applet_jump,
            type: "line",
            smooth: true,
            z: 1,
            symbol:
              "path://M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM7,2.5A4.5,4.5,0,1,0,11.5,7,4.51,4.51,0,0,0,7,2.5Z",
            symbolSize: 2,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(255, 243, 215, 1)",
                },
                {
                  offset: 1,
                  color: "rgba(255, 255, 255, 0)",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "rgba(255, 178, 2, 1)", // 改变折线点的颜色
                lineStyle: {
                  color: "rgba(255, 178, 2, 1)", // 改变折线颜色
                  width: 2, // 设置线条粗细
                },
              },
            },
          },
          {
            name: this.$t("Fm2shortlinkbate.Feemooadjump11"),
            data: this.downTable.app_jump,
            type: "line",
            smooth: true,
            z: 1,
            symbol:
              "path://M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM7,2.5A4.5,4.5,0,1,0,11.5,7,4.51,4.51,0,0,0,7,2.5Z",
            symbolSize: 2,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(216, 249, 225, 1)",
                },
                {
                  offset: 1,
                  color: "rgba(255, 255, 255, 0)",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "rgba(62, 214, 151, 1)", // 改变折线点的颜色
                lineStyle: {
                  color: "rgba(62, 214, 151, 1)", // 改变折线颜色
                  width: 2, // 设置线条粗细
                },
              },
            },
          },
        ],
      };
      option && myChart.setOption(option);
    },
    initEchart2() {
      var chartDom = document.getElementById("echart2");
      var myChart = echarts.init(chartDom);
      var option;
      (option = {
        legend: {
          data: [
            {
              name: this.$t("Fm2shortlinkbate.Loginjump11"),
              icon: "path://M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM7,2.5A4.5,4.5,0,1,0,11.5,7,4.51,4.51,0,0,0,7,2.5Z",
            },
            {
              name: this.$t("Fm2shortlinkbate.Miniadjump11"),
              icon: "path://M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM7,2.5A4.5,4.5,0,1,0,11.5,7,4.51,4.51,0,0,0,7,2.5Z",
            },
            {
              name: this.$t("Fm2shortlinkbate.Feemooadjump11"),
              icon: "path://M7,14a7,7,0,1,1,7-7A7,7,0,0,1,7,14ZM7,2.5A4.5,4.5,0,1,0,11.5,7,4.51,4.51,0,0,0,7,2.5Z",
            },
          ],
          bottom: 0,
        },
        tooltip: {
          // 设置tip提示
          trigger: "axis",
          formatter: function (params) {
            let result = "";
            result += `<div style="font-weight: 400;font-size: 12px;color: #8A8B92;line-height: 20px;;margin-bottom:8px">
              ${params[0].name}
            </div>`;
            params.forEach((item) => {
              const symbolstyle = ` 
                width: 8px;
                height: 8px;
                display:inline-block;
                border: 2.5px solid ${item.color};
                border-radius: 50%; 
                background-color: transparent; `;
              result += `
                <div style="display:flex;justify-content:space-between;align-items:center">
                  <div>
                    <span style="${symbolstyle}"></span>
                    <span style="margin-left:5px;margin-right:18px;font-weight: 400;font-size: 12px;color:#2C2C2C;">
                      ${item.seriesName}
                    </span>
                  </div>
                  <span style="font-weight: 400;font-size: 12px;color: #2C2C2C;">${item.value}</span>
                </div>`;
            });
            return result;
          },
          extraCssText:
            "box-shadow: 0px 8px 20px 0px rgba(0,0,0,0.06);border-radius: 8px;",
        },
        grid: {
          // 调整图表上下左右位置
          left: 0,
          right: 30,
          containLabel: true,
        },
        yAxis: {
          type: "value",
          axisLabel: {
            show: true,
            textStyle: {
              color: "#8a8b92", // 更改坐标轴文字颜色
              fontSize: 14, // 更改坐标轴文字大小
            },
          },
        },
        xAxis: {
          // 设置x轴
          type: "category",
          data: this.darenTable.x,

          axisLabel: {
            show: true,
            margin: 12,
            textStyle: {
              color: "#8a8b92", // 更改坐标轴文字颜色
              fontSize: 14, // 更改坐标轴文字大小
            },
          },
        },

        series: [
          {
            name: this.$t("Fm2shortlinkbate.Loginjump11"),
            data: this.darenTable.login_jump,
            z: 2,
            type: "line",
            symbolSize: 2,
            smooth: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(236, 233, 255, 1)",
                },
                {
                  offset: 1,
                  color: "rgba(236, 233, 255, 0)",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "rgba(126, 114, 246, 1)", // 改变折线点的颜色
                lineStyle: {
                  color: "rgba(126, 114, 246, 1)", // 改变折线颜色
                  width: 2, // 设置线条粗细
                },
              },
            },
          },
          {
            name: this.$t("Fm2shortlinkbate.Miniadjump11"),
            data: this.darenTable.applet_jump,
            z: 1,
            type: "line",
            smooth: true,
            symbolSize: 2,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(255, 243, 215, 1)",
                },
                {
                  offset: 1,
                  color: "rgba(255, 255, 255, 0)",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "rgba(255, 178, 2, 1)", // 改变折线点的颜色
                lineStyle: {
                  color: "rgba(255, 178, 2, 1)", // 改变折线颜色
                  width: 2, // 设置线条粗细
                },
              },
            },
          },
          {
            name: this.$t("Fm2shortlinkbate.Feemooadjump11"),
            data: this.darenTable.app_jump,
            z: 1,
            type: "line",
            smooth: true,
            symbolSize: 2,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(216, 249, 225, 1)",
                },
                {
                  offset: 1,
                  color: "rgba(255, 255, 255, 0)",
                },
              ]),
            },
            itemStyle: {
              normal: {
                color: "rgba(62, 214, 151, 1)", // 改变折线点的颜色
                lineStyle: {
                  color: "rgba(62, 214, 151, 1)", // 改变折线颜色
                  width: 2, // 设置线条粗细
                },
              },
            },
          },
        ],
      }),
        option && myChart.setOption(option);
    },
    getData1() {
      getViewsChart({
        start_time: this.$utils.initDateFormat(this.picker1[0]),
        end_time: this.$utils.initDateFormat(this.picker1[1]),
        field: this.isInside == 1 ? 'jump_volume' : 'view_volume'
      })
        .then((res) => {
          if (res.status == 1) {
            this.downTable.x = res.data.date_list;
            this.downTable.app_jump = res.data.list.map((item) => item.app_jump);
            this.downTable.applet_jump = res.data.list.map((item) => item.applet_jump);
            this.downTable.login_jump = res.data.list.map((item) => item.login_jump);
            // this.downTable.no_login_jump = res.data.list.map((item) => item.no_login_jump);
            this.downTable.file_count = parseInt(res.data.file_count);
            this.initEchart1();
            this.downNumList[1].num = res.data.lower_lewltotal;
            this.downNumList[0].num = res.data.over_lewltotal;
            this.downNumList[2].task_status = res.data.task.task_status;
            this.downNumList[2].taskId = res.data.task.tid;
          }
        })
        .catch((err) => {});
    },
    getData2() {
      getViewsChart({
        start_time: this.$utils.initDateFormat(this.picker2[0]),
        end_time: this.$utils.initDateFormat(this.picker2[1]),
        field: 'income_volume'
      })
        .then((res) => {
          if (res.status == 1) {
            this.darenTable.x = res.data.date_list;
            this.darenTable.app_jump = res.data.list.map((item) => item.app_jump);
            this.darenTable.applet_jump = res.data.list.map((item) => item.applet_jump);
            this.darenTable.login_jump = res.data.list.map((item) => item.login_jump);
            // this.darenTable.no_login_jump = res.data.list.map((item) => item.no_login_jump);
            this.darenTable.file_count = parseInt(res.data.file_count);
            this.initEchart2();
            //个数
            this.memberList[1].num = res.data.lower_lewltotal;
            //金额
            this.memberList[0].num = res.data.over_lewltotal;
          }
        })
        .catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.behind {
  background: #f6f6f6;
  border-radius: 6px;
  padding: 3px;
  margin-left: 16px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  .inside {
    cursor: pointer;
    padding: 4px 12px;
    height: 26px;
    font-weight: 400;
    font-size: 13px;
    color: rgba(44, 44, 44, 0.8);
    line-height: 18px;
    background: transparent;
    border-radius: 5px;
    &:hover {
      color: #2c2c2c;
    }
  }
  .insideA {
    background: #7e72f6;
    font-weight: 500 !important;
    color: #ffffff !important;
  }
}
.fmcloud {
  // width: 980px;
  // background: #fff;
  // border-radius: 16px 16px 0px 0px;
  // // padding: 32px 24px 72px 24px;
  // min-height: calc(100vh - 50px - 20px - 33px);
  .tips {
    font-size: 12px;
    color: #7e72f6;
    line-height: 20px;
  }
  .fmTop {
    display: flex;
    justify-content: space-between;

    .fmtit {
      height: 28px;
      line-height: 28px;
      display: flex;
      align-items: center;
      margin-right: 4px;
      .tit {
        font-weight: 600;
        font-size: 20px;
        color: #2c2c2c;
        line-height: 28px;
      }
    }
  }
}
</style>
